import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import ConfirmationPopup from '../../Common/ConfirmationPopup/ConfirmationPopup';
import {
    Button
} from 'react-bootstrap';

import { deleteImportCal } from '../../../actions/Listing/DeleteImportCalendar';
import { importiCal } from '../../../actions/Listing/ImportCalendar';
import { CalendarDeleteIcon, RefreshSvgIcon } from './CalendarSvgComponent';
import messages from '../../../locale/messages';
import { closeDeleteCalendarModal, openDeleteCalendarModal } from '../../../actions/WishList/modalActions';

import s from '../ListPlaceStep1.css';
class CalendarsList extends Component {

    static propTypes = {
        calendars: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            listId: PropTypes.number.isRequired,
        })),
        deleteImportCal: PropTypes.any.isRequired,
        importiCal: PropTypes.any.isRequired,
    };

    static defaultProps = {
        calendars: [],
    };

    handleDeleteImportCal = () => {
        const { closeDeleteCalendarModal, deleteImportCal, formData } = this.props;
        closeDeleteCalendarModal();
        deleteImportCal(formData?.listId, formData?.calendarId, formData?.calendarName)
    }

    render() {
        const { calendars, importiCal, calendarDeleteModalOpen, openDeleteCalendarModal, closeDeleteCalendarModal, formData } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className={s.syncCalendarCardContainer}>
                <ConfirmationPopup
                    modalStatus={calendarDeleteModalOpen}
                    title={formatMessage(messages.deleteCalendar)}
                    bodyText={formData?.confirmBodyText}
                    closeModal={() => closeDeleteCalendarModal()}
                    popupButtonLeftName={formatMessage(messages.cancel)}
                    popupButtonRightName={formatMessage(messages.delete)}
                    popupButtonLeftFunction={() => closeDeleteCalendarModal()}
                    popupButtonRightFunction={() => this.handleDeleteImportCal()}
                />
                {
                    calendars?.length > 0 && calendars?.map((item) => {
                        let confirmBodyText = `${formatMessage(messages.confirmDeleteCalendar)} '${item.name}' ?`;
                        let formData = {
                            confirmBodyText,
                            listId: item.listId,
                            calendarId: item.id,
                            calendarName: item.name
                        }

                        return (
                            <div key={item.id} className={s.syncCalendarCard}>
                                <div className={cx(s.calenderText)}>{item.name}</div>
                                <ul className={s.syncCalendarCardBtnGrp}>
                                    <li>
                                        <Button
                                            className={s.syncCalendarCardBtn}
                                            onClick={() => importiCal(item.listId, item.name, item.url, item.id)}
                                        >
                                            <RefreshSvgIcon className={s.iconSize} />
                                        </Button>
                                    </li>
                                    <li>
                                        <Button onClick={() => openDeleteCalendarModal(formData)} className={s.syncCalendarCardBtn}>
                                            <CalendarDeleteIcon className={s.iconSize} />
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

const mapState = (state) => ({
    calendars: state.calendar.data,
    calendarDeleteModalOpen: state.modalStatus.calendarDeleteModalOpen,
    formData: state.modalStatus.formData,
});

const mapDispatch = {
    deleteImportCal,
    importiCal,
    closeDeleteCalendarModal,
    openDeleteCalendarModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(CalendarsList))); 